<div class="row">
  <div class="container mt-2">
    <!-- <tan-loader [loading]="(productsLoading$ | async) || (getFloorplannerProductsLoading$ | async)"
      [loadingText]="'<p>Fetching design assets</p>'">
    </tan-loader> -->
    <!-- <div class="kwikspace-section" *ngIf="!(productsLoading$ | async) && !(getFloorplannerProductsLoading$ | async)"> -->
    <div class="kwikspace-section">
      <div class="row">
        <div class="col-12">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <span class="section-heading">Quote Cart</span>
                <div class="mt-2">
                  <ng-container>
                    <table class="table table-striped kwikspace-table">
                      <thead>
                        <tr>
                          <th scope="col">Asset Image</th>
                          <th scope="col">Asset Name</th>
                          <th scope="col">Product Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- <tr *ngFor="let asset of matchedAssets; let i = index">
                          <td><img [src]="asset.assetImage" class="asset-image" /></td>
                          <td>{{asset.assetName}}</td>
                          <td><b>R{{asset.assetPrice}}</b></td>
                        </tr> -->
                      </tbody>
                    </table>
                  </ng-container>
                  <!-- <ng-container *ngIf="!hasMatch">
                    <p>Sorry, the assets you have selected for your design are not available for this shell.</p>
                  </ng-container> -->
                </div>
              </div>
            </div>
            <!-- <div class="row" *ngIf="quoteCart.length == 0">
              <div class="col-sm-12">
                <tan-alert-message [errorType]="'info'" [message]="'No items in cart yet'"></tan-alert-message>
              </div>
            </div> -->
            <div class="row">
              <div class="col-sm-12">
                <!-- <ng-container *ngFor="let item of quoteCart">
                  <div class="row">
                    <label class="col-sm-12 col-form-label">
                      {{ item.name }}
                    </label>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <span><strong>Description</strong></span>
                    </div>
                    <div class="col-sm-6">
                      <span><strong>Quantity</strong></span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-6">
                      {{ item.item.name }}
                    </div>
                    <div class="col-sm-6">
                      1
                    </div>
                  </div>

                  <ng-container *ngIf="item.extras.length > 0">
                    <div class="row">
                      <div class="col-sm-12">
                        <label class="col-form-label">Added extras:</label>
                      </div>
                    </div>
                    <ng-container *ngFor="let extra of item.extras">
                      <div class="row">
                        <div class="col-sm-6">
                          {{ extra.product }}
                        </div>
                        <div class="col-sm-6">
                          {{ extra.quantity }}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>

                  <div class="row">
                    <div class="col-sm-12">
                      <label class="col-form-label">Transport to:</label>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-sm-12">
                      {{ item.transport.transport.location.province.name }} -
                      {{ item.transport.transport.location.name }}
                    </div>
                  </div>

                </ng-container> -->

                <div class="row" *ngIf="canSave">
                  <div class="col-sm-12">
                    <div class="pt-2 pb-2 ar">
                      <button type="button" class="btn btn-primary" (click)="completeQuote()">
                        <span *ngIf="!(createLineItemLoading$ | async)">Save</span>
                        <span *ngIf="(createLineItemLoading$ | async)"><i
                            class="fa fa-spinner fa-spin"></i>Saving</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>